export const ApiErrorCode = {
  VALIDATION_ERROR: 'VALIDATION_ERROR',

  UNAUTHENTICATED: 'UNAUTHENTICATED',

  FORBIDDEN: 'FORBIDDEN',

  NOT_FOUND: 'NOT_FOUND',

  APPEND_ONLY: 'APPEND_ONLY',

  DUPLICATE_COMPANY: 'DUPLICATE_COMPANY',

  FILE_TOO_LARGE: 'FILE_TOO_LARGE',

  ACCOUNT_DEACTIVATED: 'ACCOUNT_DEACTIVATED',
  RATE_LIMITED: 'RATE_LIMITED',
  INTERNAL_ERROR: 'INTERNAL_ERROR',
} as const

export type ApiErrorCode = (typeof ApiErrorCode)[keyof typeof ApiErrorCode]

export class ApiError extends Error {
  override readonly name = 'ApiError'
  readonly status: number
  readonly code: string
  readonly details: unknown
  readonly correlationId: string | undefined
  readonly route: string

  constructor(init: {
    status: number
    code: string
    error: string
    details?: unknown
    correlationId?: string | undefined
    route: string
  }) {
    super(init.error)
    this.status = init.status
    this.code = init.code
    this.details = init.details
    this.correlationId = init.correlationId
    this.route = init.route
  }
}

export class ResponseShapeError extends Error {
  override readonly name = 'ResponseShapeError'
  readonly route: string
  readonly issues: string[]

  constructor(route: string, issues: string[]) {
    super(`Unexpected response shape from ${route}:\n${issues.map((i) => `  - ${i}`).join('\n')}`)
    this.route = route
    this.issues = issues
  }
}

export class NetworkError extends Error {
  override readonly name = 'NetworkError'
  readonly route: string

  constructor(route: string, options?: { cause?: unknown }) {
    super(`Network request to ${route} failed`, options)
    this.route = route
  }
}

export function isApiError(error: unknown): error is ApiError {
  return error instanceof ApiError
}

export function isForbiddenError(error: unknown): boolean {
  return isApiError(error) && error.status === 403
}

export function isNotFoundError(error: unknown): boolean {
  return isApiError(error) && error.status === 404
}

export function isRetryableError(error: unknown): boolean {
  if (isApiError(error)) return error.status >= 500
  return error instanceof NetworkError
}
